import React, { useRef } from 'react';
import { Input } from './input';
import { Calendar } from 'lucide-react';
import { cn } from '@/lib/utils';

type DateInputProps = React.ComponentProps<'input'> & {
  wrapperClassName?: string;
  buttonWidth?: string; // percentage or css value, e.g. '14.2857%'
  /** 隱藏原生 input[type=date] 的內建圖示（預設 true） */
  hideNativePicker?: boolean;
};

export default function DateInput({ wrapperClassName, buttonWidth = '14.2857%', className, hideNativePicker = true, ...props }: DateInputProps) {
  const wrapRef = useRef<HTMLDivElement | null>(null);

  const handleClick = () => {
    const inputEl = wrapRef.current?.querySelector('input');
    if (!inputEl) return;
    try {
      // Try native showPicker if available (Chrome/Edge)
      (inputEl as any).showPicker?.();
    } catch (_e) {
      // ignore
    }
    (inputEl as HTMLInputElement).focus();
  };

  const nativeClass = hideNativePicker ? 'hide-native-picker' : '';

  return (
    <div ref={wrapRef} className={cn('relative', wrapperClassName)}>
      {/* Inline styles to hide native picker indicator when requested. */}
      {hideNativePicker && (
        <style>{`
          /* Chrome, Edge, Safari */
          .hide-native-picker::-webkit-calendar-picker-indicator { display: none; -webkit-appearance: none; }
          .hide-native-picker::-webkit-clear-button { display: none; }
          .hide-native-picker::-webkit-inner-spin-button { display: none; }
          /* Firefox */
          .hide-native-picker::-moz-calendar-picker-indicator { display: none; }
          /* Make input look like textfield to avoid native decorations */
          .hide-native-picker { -moz-appearance: textfield; appearance: none; }
        `}</style>
      )}

      <Input
        type="date"
        className={cn(className, 'pr-[18%]', nativeClass)}
        {...props}
      />
      <button
        type="button"
        onClick={handleClick}
        aria-label="選擇日期"
        title="選擇日期"
        style={{ width: buttonWidth }}
        className="absolute top-0 right-0 bottom-0 h-full flex items-center justify-center border border-white-600 bg-gray-900 text-white rounded-r-2xl"
      >
        <Calendar size={16} />
      </button>
    </div>
  );
}
